var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 873,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 874,
	"./assets/thewest-digital-hero-variation-a.jpg": 2976,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 875,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2977,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 876,
	"./assets/thewest-digital-hero-variation-b.jpg": 2978,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 877,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2979,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 878,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2980,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 879,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2981,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 880,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2982,
	"./assets/thewest-digital-hero.jpg": 2983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;